"use strict";

import _ from "lodash";

class TextEditorUtils {
  static getRangeInfo(/** Range **/ range) {
    var rangeInfo = {
      collapsed: range.collapsed,
      anchorEl: null,
      href: "",
    };

    var node = range.commonAncestorContainer;
    while (node && rangeInfo.anchorEl == null && (node.nodeType == 1 || node.nodeType == 3)) {
      if ("a" === node.nodeName.toLowerCase()) {
        rangeInfo.href = node.getAttribute("href");
        rangeInfo.anchorEl = node;
      }

      node = node.parentNode;

      //stop checking nodes once content editable node has been reached
      if (node.hasAttribute && node.hasAttribute("contenteditable")) {
        node = null;
      }
    }

    return rangeInfo;
  }

  static selectElement(/** Document **/ doc, /** Node **/ el) {
    var selection = doc.getSelection();
    var range = doc.createRange();

    range.selectNode(el);

    selection.removeAllRanges();
    selection.addRange(range);
  }

  static unwrapElement(/** Node **/ el) {
    var parent = el.parentNode;
    while (el.firstChild) parent.insertBefore(el.firstChild, el);
    parent.removeChild(el);
  }
}

export default TextEditorUtils;
